/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';

import {
  IAddressInfoSchema,
  IHighwayInfoSchema,
  IUndergroundInfoSchema,
} from '@cian/api-models/offer-card/v1/get-offer-data';
import { UndergroundIcon } from '../../../common/components/underground_icon';
import { isArrayWithItems, isDefined, PREMIUM_REGIONS_IDS } from '../../../utils';
import { getUndergroundTime } from '../../../utils/formatters';
import { ParentContainer } from '../../parent/container';
import { trackGeoAddressNodeClick, trackGeoUndergroundClick } from '../tracking';

import * as styles from './index.css';

export interface IOfferMapGeoProps {
  address: IAddressInfoSchema[];
  undergrounds: IUndergroundInfoSchema[] | null;
  highways: IHighwayInfoSchema[] | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class OfferMapGeo extends React.Component<IOfferMapGeoProps, {}> {
  public render() {
    const { address, undergrounds, highways } = this.props;

    if (!isArrayWithItems(address)) {
      return null;
    }

    const regionId = address[0].id;
    const addressElements = address.map((addr, index) => (
      <a key={`addressElement_${index}`} href={addr.url} target="_blank" onClick={trackGeoAddressNodeClick}>
        {addr.shortName}
      </a>
    ));

    return (
      <div className={styles['container']}>
        <ParentContainer containerClassName={styles['name']} withoutPretext />
        <div className={styles['address']}>
          {addressElements
            .slice(1)
            .reduce<(string | JSX.Element)[]>((xs, x, i) => xs.concat([', ', x]), [addressElements[0]])}
        </div>
        {undergrounds && (
          <div className={styles['undergrounds']}>
            {undergrounds.map(underground => renderUnderground(underground, regionId))}
          </div>
        )}
        {highways && <div className={styles['highways']}>{highways.map(renderHighway)}</div>}
      </div>
    );
  }
}

function renderHighway(highway: IHighwayInfoSchema) {
  return (
    <div key={`underground_${highway.name}`} className={styles['highway']}>
      <a href={highway.url} target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
          {/* tslint:disable-next-line:max-line-length */}
          <path
            fill="#757575"
            fillOpacity=".54"
            fillRule="evenodd"
            d="M10.037 1.506a.872.872 0 0 0-.83-.59H2.793a.877.877 0 0 0-.83.59L.75 5v4.667c0 .32.262.583.583.583h.584c.32 0 .583-.262.583-.583v-.584h7v.584c0 .32.262.583.583.583h.584c.32 0 .583-.262.583-.583V5l-1.213-3.494zM2.792 7.333a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75zm6.416 0a.874.874 0 1 1 0-1.75.874.874 0 1 1 0 1.75zm-7.29-2.916l.874-2.625h6.416l.875 2.625H1.917z"
          />
        </svg>
        {`${highway.name} шоссе`}
      </a>
      , <span className={styles['highway-distance']}>{Math.round(highway.distance)} км от МКАД</span>
    </div>
  );
}

function renderUnderground(underground: IUndergroundInfoSchema, regionId: number) {
  const size = PREMIUM_REGIONS_IDS.includes(regionId) ? 17 : 10;

  return (
    <div key={`underground_${underground.name}`} className={styles['underground']}>
      <a href={underground.url} target="_blank" onClick={trackGeoUndergroundClick}>
        <UndergroundIcon width={size} height={size} color={`#${underground.lineColor}`} regionId={regionId} />
        {underground.name}
      </a>
      {isDefined<number>(underground.travelTime) && underground.travelType && (
        <span className={styles['underground-time']}>{getUndergroundTime(underground)}</span>
      )}
    </div>
  );
}
